import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { StudentAttendanceService } from '../student-attendance.service';
import { StudentAttendanceCampusComponent } from '../student-attendance-campus/student-attendance-campus.component';
import { AttendanceFilterResult, StudentAttendanceFilterComponent } from '../student-attendance-filter/student-attendance-filter.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
interface Student {
  admNo: string;
  name: string;
  course: string;
  section: string;
  attendance: string;
  remarks: string;
  remarksRequired?: boolean;
  showRemarks?: boolean;
  transferredIn?: boolean;
  transferredOut?: boolean;
  _prevAttendance?: string;
  _outingRemarks?: string;
  _absentRemarks?: string;
  _hadApiStatus?: boolean;
  _baselineStatus?: string;
  _baselineRemarks?: string;
}
@Component({
  selector: 'app-student-attendance',
  templateUrl: './student-attendance.component.html',
  styleUrls: ['./student-attendance.component.scss']
})
export class StudentAttendanceComponent {
displayedColumns: string[] = ['sno', 'admNo', 'name', 'course', 'section', 'status', 'remarks'];
  students: Student[] = [];

  totalStudents = 0;
  presentCount = 0;
  absentCount = 0;
  outingCount = 0;
  sickCount = 0;
  leftCount = 0;
  transferInCount = 0;
  transferOutCount = 0;

  attendanceDate: Date = new Date();

  holidaysChecked: boolean = false;
  presentChecked: boolean = false;
  absentChecked: boolean = false;
  outingChecked: boolean = false;
  selectedStatus: string = '';
  /** Last bulk H/P/A/O applied. Used to re-check bulk when every row is back to that status. */
  private lastBulkStatus: string = '';
  /** User unchecked header while all rows still share a status — do not auto-tick until a row changes. */
  private bulkManuallyUnchecked = false;
  /** True after bulk H/P/O — save sends the full section. Cleared when one student is changed. */
  private saveAsSectionBulk = false;

  studentclasslist: any;
  filteredStudyClassList: any[] = [];
  selectedStudyClassId: any = null;
  selectedStudyClassName: string = '';
  studyClassQuery: string = '';

  buildingList: any;
  filteredBuildingList: any[] = [];
  selectedBuildingId: number | null = null;
  selectedBuildingName: string = '';
  buildingQuery: string = '';

  sectionList: any;
  filteredSectionList: any[] = [];
  selectedSectionId: any = null;
  selectedSectionName = '';
  sectionQuery = '';
  hasStudents = false;
  studentsNotAllotted = false;
  activeTab: 'campus' | 'section' = 'campus';


  maxDate = new Date();
  @ViewChild('searchStudyClassInput') searchStudyClassInput!: ElementRef;
  @ViewChild('searchBuildingInput') searchBuildingInput!: ElementRef;
  @ViewChild('searchSectionInput') searchSectionInput!: ElementRef;
  campusstudentcount: any;
  filterStatus: string = 'ALL';
  isStatsExpanded: boolean = true;
  tableSearchQuery = '';
  /** Longer toast duration for student attendance screens only (ms). */
  private readonly attendanceToastMs = 8000;
  showSaveConfirm = false;
  confirmRows: Array<{ label: string; value: string }> = [];
  private pendingStudentsToSave: any[] = [];

  constructor(
    private data: StudentAttendanceService,
    private dialog: NgDialogAnimationService,
    private spinner: NgxSpinnerService,
    private toast: ToastmessageService
  ) { }

  /**
   * Centered modal — same pattern as Hygiene Day Wise filter / images dialogs
   * (`width` + `maxHeight`, default backdrop, click outside closes).
   */
  private readonly filterDialogConfig = {
    width: 'min(520px, 92vw)',
    maxHeight: '85vh',
    autoFocus: false,
    panelClass: 'attendance-filter-dialog'
  };

  private readonly campusSummaryDialogConfig = {
    width: 'min(900px, 92vw)',
    maxHeight: '90vh',
    autoFocus: false,
    panelClass: ['campus-summary-dialog', 'hdwi-images-dialog-panel']
  };

  /** Open campus summary dialog (8 cards) when user clicks campus / cards */
  openCampusSummaryDialog(): void {
    const dateStr = this.getFormattedDate(this.attendanceDate);
    this.dialog.open(StudentAttendanceCampusComponent, {
      width: 'min(520px, 92vw)',
      height: '100%',
      maxHeight: '100vh',
      panelClass: ['animate__animated', 'animate__slideInRight', 'hdw-filter-dialog-anim'],
      position: { right: '0' },
      maxWidth: '100%',
      animation: { to: 'left' },
      autoFocus: false,
      data: { summary: this.campusstudentcount, attendanceDate: dateStr }
    });
  }

  openAttendanceFilterDialog(): void {
    const dialogRef = this.dialog.open(StudentAttendanceFilterComponent, {
      width: 'min(520px, 92vw)',
      height: '100%',
      maxHeight: '100vh',
      panelClass: ['animate__animated', 'animate__slideInRight', 'hdw-filter-dialog-anim'],
      position: { right: '0' },
      maxWidth: '100%',
      animation: { to: 'left' },
      autoFocus: false,
      data: {
        attendanceDate: this.attendanceDate,
        selectedStudyClassId: this.selectedStudyClassId,
        selectedStudyClassName: this.selectedStudyClassName,
        selectedBuildingId: this.selectedBuildingId,
        selectedBuildingName: this.selectedBuildingName,
        selectedSectionId: this.selectedSectionId,
        selectedSectionName: this.selectedSectionName
      }
    });
    dialogRef.afterClosed().subscribe((result: AttendanceFilterResult | undefined) => {
      if (!result) return;
      this.attendanceDate = result.attendanceDate;
      this.selectedStudyClassId = result.selectedStudyClassId;
      this.selectedStudyClassName = result.selectedStudyClassName;
      this.selectedBuildingId = result.selectedBuildingId;
      this.selectedBuildingName = result.selectedBuildingName;
      this.selectedSectionId = result.selectedSectionId;
      this.selectedSectionName = result.selectedSectionName;
      if (this.selectedSectionId) {
        this.activeTab = 'section';
        this.filterStatus = 'ALL';
        this.loadAttendanceStudents();
      }
    });
  }
  ngOnInit(): void {
    this.getclass()
    this.getBuildings();
    // Open filter dialog by default when page loads
    setTimeout(() => this.openAttendanceFilterDialog(), 0);
  }

  getclass() {
    this.spinner.show();
    this.data.getstudentclass().subscribe({
      next: (res: any) => {
        this.studentclasslist = Array.isArray(res) ? res : [];
        this.filteredStudyClassList = [...this.studentclasslist];
        this.spinner.hide();
      },
      error: (err) => {
        console.error('Study class API error', err);
        this.studentclasslist = [];
        this.filteredStudyClassList = [];
        this.spinner.hide();
      }
    });
  }
  getBuildings() {
    this.spinner.show();
    this.data.getstundentbuilding().subscribe({
      next: (res: any) => {
        this.buildingList = Array.isArray(res) ? res : [];
        this.filteredBuildingList = [...this.buildingList];
        this.spinner.hide();
      },
      error: () => {
        this.buildingList = [];
        this.filteredBuildingList = [];
        this.spinner.hide();
      }
    });
  }

  loadSections() {
    if (!this.selectedStudyClassId || !this.selectedBuildingId) {
      this.sectionList = [];
      this.filteredSectionList = [];
      return;
    }
    this.spinner.show();
    this.data.getstudentsection(this.selectedStudyClassId, this.selectedBuildingId)
      .subscribe({
        next: (res: any) => {
          this.sectionList = Array.isArray(res) ? res : [];
          this.filteredSectionList = [...this.sectionList];
          if (!this.sectionList.length) {
            this.selectedSectionId = null;
            this.selectedSectionName = '';
            this.toast.showWarning('No Section', this.attendanceToastMs);
          }
          this.spinner.hide();
        },
        error: (err) => {
          console.error('Section API failed', err);
          this.sectionList = [];
          this.filteredSectionList = [];
          this.selectedSectionId = null;
          this.selectedSectionName = '';
          this.toast.showWarning('No Section', this.attendanceToastMs);
          this.spinner.hide();
        }
      });
  }
  selectStudyClass(cls: any) {
    this.selectedStudyClassId = cls.id;
    this.selectedStudyClassName = cls.studyClass;

    // reset dependent dropdowns
    this.selectedBuildingId = null;
    this.selectedBuildingName = '';

    this.selectedSectionId = null;
    this.selectedSectionName = '';

    this.sectionList = [];
    this.filteredSectionList = [];
  }
  selectBuilding(b: any) {
    this.selectedBuildingId = b.buildingId;
    this.selectedBuildingName = b.buildingName;

    this.selectedSectionId = null;
    this.selectedSectionName = '';

    this.loadSections();
  }
  selectSection(s: any) {
    this.selectedSectionId = s.id;
    this.selectedSectionName = s.sectionName;
    this.activeTab = 'section'; // Automatically switch tab
    this.filterStatus = 'ALL';
    this.loadAttendanceStudents();
  }
  focusStudyClassInput() {
    setTimeout(() => {
      this.searchStudyClassInput?.nativeElement.focus();
    }, 200);
  }
  focusBuildingInput() {
    setTimeout(() => {
      this.searchBuildingInput?.nativeElement.focus();
    }, 200);
  }
  focusSectionInput() {
    setTimeout(() => {
      this.searchSectionInput?.nativeElement.focus();
    }, 200);
  }
  filterStudyClasses() {
    const query = this.studyClassQuery.toLowerCase();

    this.filteredStudyClassList = this.studentclasslist.filter((cls:any) =>
      cls.studyClass.toLowerCase().includes(query)
    );
  }
  filterBuildings() {
    const query = this.buildingQuery.toLowerCase();

    this.filteredBuildingList = this.buildingList.filter((b:any) =>
      b.buildingName.toLowerCase().includes(query)
    );
  }
  filterSections() {
    const query = this.sectionQuery.toLowerCase();
    this.filteredSectionList = this.sectionList.filter((s: any) =>
      s.sectionName.toLowerCase().includes(query)
    );
  }

  toggleBulkAttendance(status: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    if (status !== 'H' && status !== 'P' && status !== 'O') {
      return;
    }
    if (this.selectedStatus === status) {
      this.selectedStatus = '';
      this.lastBulkStatus = '';
      this.bulkManuallyUnchecked = true;
      this.saveAsSectionBulk = false;
      this.hideAllRemarks();
      this.loadAttendanceStudents();
      return;
    }
    this.bulkManuallyUnchecked = false;
    this.saveAsSectionBulk = true;
    this.selectedStatus = status;
    this.lastBulkStatus = status;
    this.students.forEach(student => {
      if (this.isAttendanceReadonly(student)) {
        return;
      }
      student.attendance = status;
      student.showRemarks = false;
      student._prevAttendance = status;
      if (status === 'H') {
        student.remarks = 'Holiday';
      } else {
        student.remarks = '';
      }
    });
    this.onAnyAttendanceUpdate();
  }

  isRemarkInputVisible(student: Student): boolean {
    return !!student?.showRemarks
      && !this.isAttendanceReadonly(student)
      && (student.attendance === 'A' || student.attendance === 'O');
  }

  private hideAllRemarks(): void {
    this.students.forEach(student => {
      student.showRemarks = false;
    });
  }

  private editableStudents(): Student[] {
    return this.students.filter((s) => !this.isAttendanceReadonly(s));
  }

  /** Tick bulk H/P/O when every editable student has that same status; otherwise uncheck. */
  private syncBulkIfAllMatch(hideRemarksWhenChecked = true): void {
    const rows = this.editableStudents();
    if (!rows.length) {
      this.selectedStatus = '';
      return;
    }
    const first = rows[0].attendance;
    const isBulkCode = first === 'H' || first === 'P' || first === 'O';
    const allSame = isBulkCode && rows.every((s) => s.attendance === first);
    if (!allSame) {
      this.selectedStatus = '';
      this.bulkManuallyUnchecked = false;
      return;
    }
    if (this.bulkManuallyUnchecked) {
      this.selectedStatus = '';
      return;
    }
    this.selectedStatus = first;
    this.lastBulkStatus = first;
    if (hideRemarksWhenChecked) {
      this.hideAllRemarks();
    }
  }

  private applyIndividualRemarks(student: any): void {
    const prev = student._prevAttendance;
    const status = student.attendance;
    if (prev === 'O') {
      student._outingRemarks = student.remarks || '';
    } else if (prev === 'A') {
      student._absentRemarks = student.remarks || '';
    }
    if (this.lastBulkStatus && status === this.lastBulkStatus) {
      student.showRemarks = false;
      if (status === 'H') {
        student.remarks = 'Holiday';
      }
    } else if (status === 'O') {
      student.showRemarks = true;
      student.remarks = student._outingRemarks || '';
    } else if (status === 'A') {
      student.showRemarks = true;
      student.remarks = student._absentRemarks || '';
    } else {
      student.showRemarks = false;
    }
    student._prevAttendance = status;
  }

  updateAttendance(status: string, event: Event) {
    this.toggleBulkAttendance(status, event);
  }
  loadAttendanceStudents() {
    if (!this.selectedSectionId) {
      this.studentsNotAllotted = false;
      return;
    }
    const dateStr = this.getFormattedDate(this.attendanceDate);
    this.spinner.show();
    this.data.getSectionStudentAttendance(this.selectedSectionId, dateStr).subscribe({
      next: (list: any[]) => {
        // 200 + [] → empty list, then spinner hides below
        if (!list?.length) {
          this.applyEmptyStudentsState();
        } else {
          this.hasStudents = true;
          this.studentsNotAllotted = false;
          this.bulkManuallyUnchecked = false;
          this.students = list.map((item: any) => {
            const rawStatus = String(
              item.attendance ?? item.attendanceStatus ?? item.status ?? item.stdAttendanceStatus ?? ''
            ).trim();
            // Tick only when GET returns a real saved status for today
            const hadApiStatus = !!rawStatus && rawStatus.toUpperCase() !== 'NULL' && rawStatus !== '-';
            // UI default Present when API has no status yet (first-time attendance)
            const attendance = hadApiStatus ? this.convertToCode(rawStatus) : 'P';
            const remarks = ['Present', 'Absent', 'Outing', 'Holiday', 'Left', 'Sick']
              .includes(item.remarks)
              ? ''
              : (item.remarks || '');
            return {
              admNo: item.admNo,
              name: item.studentName ?? item.name ?? '',
              course: item.courseTrackName ?? item.courseName ?? '',
              section: item.sectionName ?? this.selectedSectionName ?? '',
              attendance,
              remarks,
              transferredIn: item.transferredIn === true || item.transferredIn === 'true' || item.transferredIn === 1,
              transferredOut: item.transferredOut === true || item.transferredOut === 'true' || item.transferredOut === 1,
              _outingRemarks: attendance === 'O' ? remarks : '',
              _absentRemarks: attendance === 'A' ? remarks : '',
              _prevAttendance: attendance,
              _hadApiStatus: hadApiStatus,
              _baselineStatus: attendance,
              _baselineRemarks: remarks,
              showRemarks: !!remarks &&
                !['Present', 'Absent', 'Outing', 'Holiday', 'Left', 'Sick'].includes(item.remarks) &&
                (attendance === 'A' || attendance === 'O')
            };
          });
          this.syncBulkIfAllMatch(false);
          this.refreshSectionSummaryCards();
        }
        this.spinner.hide();
      },
      error: err => {
        console.error('Attendance API error', err);
        this.applyEmptyStudentsState();
        this.spinner.hide();
      }
    });
  }

  /** Stat cards always from sectionSummary API — never from local row counting. */
  private refreshSectionSummaryCards(): void {
    this.loadSectionSummary();
  }

  private applyEmptyStudentsState(): void {
    this.students = [];
    this.hasStudents = false;
    this.studentsNotAllotted = true;
    this.selectedStatus = '';
    this.lastBulkStatus = '';
    this.bulkManuallyUnchecked = false;
    this.saveAsSectionBulk = false;
    this.totalStudents = 0;
    this.presentCount = 0;
    this.absentCount = 0;
    this.outingCount = 0;
    this.sickCount = 0;
    this.leftCount = 0;
    this.transferInCount = 0;
    this.transferOutCount = 0;
  }
  convertToFullName(status: string): string {
    switch (status?.toUpperCase()) {
      case 'P':
      case 'PRESENT': return 'PRESENT';
      case 'A':
      case 'ABSENT': return 'ABSENT';
      case 'L':
      case 'LEFT': return 'LEFT';
      case 'S':
      case 'SICK': return 'SICK';
      case 'O':
      case 'OUTING': return 'OUTING';
      case 'H':
      case 'HOLIDAY': return 'HOLIDAY';
      default: return '';
    }
  }

  /** API returns PRESENT / ABSENT — UI uses P / A / etc. */
  convertToCode(status: string): string {
    switch (status?.toUpperCase()) {
      case 'P':
      case 'PRESENT': return 'P';
      case 'A':
      case 'ABSENT': return 'A';
      case 'L':
      case 'LEFT': return 'L';
      case 'S':
      case 'SICK': return 'S';
      case 'O':
      case 'OUTING': return 'O';
      case 'H':
      case 'HOLIDAY': return 'H';
      default: return '';
    }
  }
  /** Transfer In / Out students — status is view-only (cannot change attendance). */
  isAttendanceReadonly(student: any): boolean {
    return !!student?.transferredIn || !!student?.transferredOut;
  }

  onIndividualStatusChange(student: any) {
    if (this.isAttendanceReadonly(student)) {
      return;
    }
    const prev = student._prevAttendance;
    const status = student.attendance;

    if (prev === 'O') {
      student._outingRemarks = student.remarks || '';
    } else if (prev === 'A') {
      student._absentRemarks = student.remarks || '';
    }

    if (status === 'O') {
      student.showRemarks = true;
      student.remarks = student._outingRemarks || '';
    } else if (status === 'A') {
      student.showRemarks = true;
      student.remarks = student._absentRemarks || '';
    } else {
      student.showRemarks = false;
    }

    student._prevAttendance = status;
    this.onAnyAttendanceUpdate();
  }
  campuschanged() {
    this.activeTab = 'campus';
  }

  refreshCampusSummary(): void {
  
  }

  /** Campus Attendances button: switch to campus tab, show stats, load campus summary data */
  showCampusAttendancesData(): void {
    this.activeTab = 'campus';
    this.isStatsExpanded = true;

  }
  setBulkAttendance(status: string) {
    this.students.forEach(student => {
      if (this.isAttendanceReadonly(student)) {
        return;
      }
      student.attendance = status;
      student.showRemarks = false;
    });
    this.onAnyAttendanceUpdate();
  }

  // Individual attendance change
  onAttendanceChange(student: any, status: string) {
    if (this.isAttendanceReadonly(student)) {
      return;
    }
    if (this.selectedStatus && student.attendance === status) {
      student.showRemarks = false;
      student._prevAttendance = status;
      return;
    }
    if (student.attendance === status) {
      return;
    }
    this.saveAsSectionBulk = false;
    student.attendance = status;
    this.applyIndividualRemarks(student);
    this.syncBulkIfAllMatch();
    this.onAnyAttendanceUpdate();
  }
  /** True when no student had attendance from API (first save for this date/section). */
  isFirstAttendanceSave(): boolean {
    return !this.students.length || this.students.every((s: any) => !s._hadApiStatus);
  }

  /** Student status/remarks changed from what was loaded. */
  isStudentAttendanceDirty(stu: any): boolean {
    const currentRemarks = (stu.remarks || '').trim();
    const baselineRemarks = (stu._baselineRemarks || '').trim();
    return stu.attendance !== stu._baselineStatus || currentRemarks !== baselineRemarks;
  }

  /**
   * Tick = today's attendance already saved on server (GET returned status)
   * and user has not changed it again. Helps confirm today's check-in.
   */
  showAttendanceSavedTick(stu: any): boolean {
    return !!stu?._hadApiStatus && !this.isStudentAttendanceDirty(stu);
  }

  /**
   * Build save list:
   * - First time (no API statuses yet): send ALL students (default Present)
   * - Later: send changed students
   * - Transfer In/Out (or any new row) with no API status yet: include default Present
   */
  getStudentsForSavePayload(): any[] {
    const editable = this.students.filter((stu: any) => !this.isAttendanceReadonly(stu));
    if (this.saveAsSectionBulk || this.isFirstAttendanceSave()) {
      return editable;
    }
    return editable.filter((stu: any) => !stu._hadApiStatus || this.isStudentAttendanceDirty(stu));
  }

  closeSaveConfirm(): void {
    this.showSaveConfirm = false;
    this.pendingStudentsToSave = [];
  }

  private openSaveConfirm(studentsToSave: any[]): void {
    this.pendingStudentsToSave = studentsToSave;
    this.confirmRows = [
      { label: 'Section', value: this.selectedSectionName || '-' },
      { label: 'Date', value: this.getFormattedDate(this.attendanceDate) || '-' },
      { label: 'Total Students', value: String(this.totalStudents || this.students.length) },
      { label: 'Present', value: String(this.presentCount) },
      { label: 'Absent', value: String(this.absentCount) },
      { label: 'Sick', value: String(this.sickCount) },
      { label: 'Outing', value: String(this.outingCount) }
    ];
    this.showSaveConfirm = true;
  }

  confirmSaveAttendance(): void {
    const studentsToSave = this.pendingStudentsToSave;
    if (!studentsToSave?.length) {
      this.closeSaveConfirm();
      return;
    }
    this.showSaveConfirm = false;
    this.spinner.show();
    const payload = {
      studentAttendanceStatus: studentsToSave.map((stu: any) => ({
        admNo: stu.admNo,
        attendanceStatus: this.convertToFullName(stu.attendance),
        remarks: stu.remarks?.trim() || ''
      })),
      attendanceDate: this.getFormattedDate(this.attendanceDate),
      source: 'web'
    };
    this.data.saveattendances(this.selectedSectionId, payload)
      .subscribe({
        next: (res: any) => {
          this.pendingStudentsToSave = [];
          this.toast.showSuccess(res.message, this.attendanceToastMs);
          this.loadAttendanceStudents();
        },
        error: (err) => {
          console.error(err);
          this.pendingStudentsToSave = [];
          alert('Save failed');
          this.spinner.hide();
        }
      });
  }

  saveAttendanceRecords() {
    if (!this.canSaveAttendance) {
      return;
    }
    const invalidStudents = this.students.filter(stu =>
      (stu.attendance === 'A' || stu.attendance === 'O') &&
      stu.showRemarks &&
      (!stu.remarks || stu.remarks.trim() === '')
    );
    if (invalidStudents.length) {
      alert('Remarks are mandatory for Absent (A) and Outing (O)');
      return;
    }

    const studentsToSave = this.getStudentsForSavePayload();
    if (!studentsToSave.length) {
      this.toast.showError('No attendance changes to save', this.attendanceToastMs);
      return;
    }

    this.openSaveConfirm(studentsToSave);
  }
  /** Update P/A/O/S/L cards immediately when attendance changes. */
  onAnyAttendanceUpdate(): void {
    this.applyCountsFromStudentRows();
  }

  /**
   * Live counts from table rows (same rules as sectionSummary):
   * - Total = section students only (Transfer Out excluded)
   * - P/A/O/S/L = all rows including Transfer Out
   * - TI/TO = transfer flags
   */
  private applyCountsFromStudentRows(): void {
    const all = this.students || [];
    const section = all.filter((s: any) => !s.transferredOut);
    this.totalStudents = section.length;
    this.presentCount = all.filter((s: any) => s.attendance === 'P').length;
    this.absentCount = all.filter((s: any) => s.attendance === 'A').length;
    this.outingCount = all.filter((s: any) => s.attendance === 'O').length;
    this.sickCount = all.filter((s: any) => s.attendance === 'S').length;
    this.leftCount = all.filter((s: any) => s.attendance === 'L').length;
    this.transferInCount = all.filter((s: any) => !!s.transferredIn).length;
    this.transferOutCount = all.filter((s: any) => !!s.transferredOut).length;
  }

  /** Apply sectionSummary API to stat cards (used on load / after save). */
  applySectionSummary(res: any): void {
    if (!res) {
      return;
    }
    this.totalStudents = Number(res.totalStudents ?? res.total ?? 0);
    this.presentCount = Number(res.totalPresent ?? res.presentCount ?? res.present ?? 0);
    this.absentCount = Number(res.totalAbsent ?? res.absentCount ?? res.absent ?? 0);
    this.outingCount = Number(res.totalOuting ?? res.outingCount ?? res.outing ?? 0);
    this.sickCount = Number(res.totalSick ?? res.sickCount ?? res.sick ?? 0);
    this.leftCount = Number(res.totalLeft ?? res.leftCount ?? res.left ?? 0);
    this.transferInCount = Number(res.transferredInCount ?? res.transferInCount ?? res.transferIn ?? 0);
    this.transferOutCount = Number(res.transferredOutCount ?? res.transferOutCount ?? res.transferOut ?? 0);
  }

  setFilter(status: string) {
    if (status === 'TI' && !this.transferInCount) {
      this.toast.showWarning('No Transfer In records', this.attendanceToastMs);
      return;
    }
    if (status === 'TO' && !this.transferOutCount) {
      this.toast.showWarning('No Transfer Out records', this.attendanceToastMs);
      return;
    }
    if (this.filterStatus === status) {
      this.filterStatus = 'ALL';
    } else {
      this.filterStatus = status;
    }
  }

  /** All filter fields selected (date, class, building, section). */
  isFilterComplete(): boolean {
    return !!this.attendanceDate &&
      this.selectedStudyClassId != null && this.selectedStudyClassId !== '' &&
      this.selectedBuildingId != null &&
      this.selectedSectionId != null && this.selectedSectionId !== '';
  }

  /** Every student has P / A / L / S / O / H selected. */
  isAllAttendanceSelected(): boolean {
    if (!this.students.length) {
      return false;
    }
    const valid = ['P', 'A', 'L', 'S', 'O', 'H'];
    return this.students.every(s => valid.includes((s.attendance || '').toUpperCase()));
  }

  get canSaveAttendance(): boolean {
    return this.isFilterComplete() && this.hasStudents && this.isAllAttendanceSelected();
  }

  getFilteredTableStudents(): Student[] {
    let list = this.students;
    if (this.filterStatus === 'TI') {
      list = list.filter((s) => !!s.transferredIn);
    } else if (this.filterStatus === 'TO') {
      list = list.filter((s) => !!s.transferredOut);
    } else if (this.filterStatus !== 'ALL') {
      list = list.filter((s) => s.attendance === this.filterStatus);
    }
    const q = (this.tableSearchQuery || '').trim().toLowerCase();
    if (!q) return list;
    return list.filter(s =>
      (s.name || '').toLowerCase().includes(q) ||
      (s.admNo || '').toLowerCase().includes(q) ||
      (s.course || '').toLowerCase().includes(q) ||
      (s.section || '').toLowerCase().includes(q)
    );
  }

  onTableSearchChange(): void {
    // Triggers change detection so table updates (getFilteredTableStudents is re-evaluated)
  }

  toggleStats() {
    this.isStatsExpanded = !this.isStatsExpanded;
  }

  getFormattedDate(date: Date): string {
    if (!date) return '';
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  loadSectionSummary() {
    if (!this.selectedSectionId) return;
    const dateStr = this.getFormattedDate(this.attendanceDate);
    this.data.getsectionSummary(this.selectedSectionId, dateStr).subscribe({
      next: (res: any) => {
        this.applySectionSummary(res);
      },
      error: (err) => {
        console.error('Section summary API error', err);
      }
    });
  }
}
